"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var lodash_1 = require("lodash");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var operators_1 = require("rxjs/operators");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var services_1 = require("../../../services");
var sis_control_with_settings_1 = require("../../sis-control-with-settings");
require("./sis-date-time-picker.component.scss");
var sis_date_time_settings_component_1 = require("./sis-date-time-settings.component");
var SisDateTimePickerComponent = /** @class */ (function (_super) {
    __extends(SisDateTimePickerComponent, _super);
    function SisDateTimePickerComponent(formattingService) {
        var _this = _super.call(this) || this;
        _this.formattingService = formattingService;
        _this.id = '';
        _this.valueChange = new core_1.EventEmitter();
        _this._date = undefined;
        _this._time = undefined;
        _this._localeInfo = undefined;
        _this._dateTime$ = new ReplaySubject_1.ReplaySubject(1);
        _this._emitValue$ = new ReplaySubject_1.ReplaySubject(1);
        return _this;
    }
    Object.defineProperty(SisDateTimePickerComponent.prototype, "dateTime$", {
        get: function () {
            return this._dateTime$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDateTimePickerComponent.prototype, "date", {
        get: function () {
            return this._date;
        },
        set: function (value) {
            this._date = value;
            this.emitDateTime();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDateTimePickerComponent.prototype, "time", {
        get: function () {
            return this._time;
        },
        set: function (value) {
            this._time = value;
            this.emitDateTime();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDateTimePickerComponent.prototype, "localeInfo", {
        get: function () {
            return this._localeInfo;
        },
        set: function (value) {
            this._localeInfo = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDateTimePickerComponent.prototype, "dateValue", {
        set: function (value) {
            this._dateTime$.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDateTimePickerComponent.prototype, "isReadonly", {
        get: function () {
            return this._isReadonly;
        },
        set: function (value) {
            this._isReadonly = value;
        },
        enumerable: true,
        configurable: true
    });
    SisDateTimePickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.localeInfo$ = this.formattingService.getLocaleInfo().pipe(operators_1.map(function (localeInfo) {
            _this.localeInfo = localeInfo;
            return localeInfo;
        }), operators_1.publishReplay(1), operators_1.refCount());
        var valueSetter$ = combineLatest_1.combineLatest(this._dateTime$, this.localeInfo$).pipe(operators_1.tap(function (_a) {
            var dateTime = _a[0], localeInfo = _a[1];
            if (lodash_1.isNil(dateTime)) {
                _this._date = undefined;
                _this._time = '00:00';
            }
            else {
                var _b = reinterpretDateInGivenZoneAndReturnAsUTCDateAndTime(dateTime, getTimeZoneOffsetMilliseconds(localeInfo.timeZoneOffset)), utcDate = _b[0], timeValue = _b[1];
                _this._date = utcDate;
                _this._time = timeToString(timeValue, localeInfo.timePattern);
            }
            _this.emitDateTime();
        }));
        var emitter$ = combineLatest_1.combineLatest(this._emitValue$.pipe(operators_1.distinctUntilChanged(lodash_1.isEqual)), this.localeInfo$).pipe(operators_1.tap(function (_a) {
            var dateTime = _a[0], locale = _a[1];
            if (lodash_1.isNil(dateTime.time) || lodash_1.isNil(dateTime.date)) {
                // tslint:disable-next-line:no-null-keyword
                _this.valueChange.emit(null);
                return;
            }
            var time = stringToTime(dateTime.time);
            _this.valueChange.emit(new Date(Date.UTC(dateTime.date.getUTCFullYear(), dateTime.date.getUTCMonth(), dateTime.date.getUTCDate(), time.hour, time.minute, time.seconds) - getTimeZoneOffsetMilliseconds(locale.timeZoneOffset)));
        }));
        this.isReady$ = combineLatest_1.combineLatest(valueSetter$, emitter$).pipe(operators_1.mapTo(true));
    };
    SisDateTimePickerComponent.prototype.emitDateTime = function () {
        this._emitValue$.next({ date: this._date, time: this._time });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisDateTimePickerComponent.prototype, "id", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], SisDateTimePickerComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Date),
        __metadata("design:paramtypes", [Date])
    ], SisDateTimePickerComponent.prototype, "dateValue", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisDateTimePickerComponent.prototype, "isReadonly", null);
    SisDateTimePickerComponent = __decorate([
        core_1.Component({
            selector: 'sis-date-time-picker',
            template: require('./sis-date-time-picker.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Date time picker',
            settings: {
                main: sis_date_time_settings_component_1.SisDateTimeSettingsComponent,
            },
            template: "<sis-date-time-picker\n                        [id]=\"'%{id}'\"\n                        [dateValue]=\"%{field}\"\n                        [hint]=\"%{hint}\"\n                        [isReadonly]=\"%{isReadonly}\"\n                        (valueChange)=\"actions.simpleChange(contextEntity, '%{field-name}', $event)\">\n               </sis-date-time-picker>",
            cellCount: 4,
            isFieldBound: true,
        })
        /**
         *
         * Given:
         *      sis-date-picker component always works with UTC dates e.g.
         *          if user selects 01/01/2021 it will return '01 Jan 2021 00:00:00 GMT' JS Date Object
         *      sis-time-picker component returns time in string without taking in account locale's offset or browser's zone
         *      timeZoneOffset field in the locale is described in seconds
         * Then:
         *      sis-date-time-picker component works in zone offset described in the locale
         *          if zone offset is null then zone offset is taken from browser
         * Examples
         *      given this inputs
         *          date: 01/01/2021
         *          time: 11:11
         *          locale zone offset: 7200
         *          browsers offset: *anything*
         *      component should emit
         *          '01 Jan 2021 09:11:00 GMT' JS Date Object
         *
         *      given this inputs
         *          date: 01/01/2021
         *          time: 11:11
         *          locale zone offset: null
         *          browsers offset: 10800
         *      component should emit
         *          '01 Jan 2021 08:11:00 GMT' JS Date Object
         */
        ,
        __metadata("design:paramtypes", [services_1.FormattingService])
    ], SisDateTimePickerComponent);
    return SisDateTimePickerComponent;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisDateTimePickerComponent = SisDateTimePickerComponent;
function stringToTime(time) {
    var result = { hour: 0, minute: 0, seconds: 0 };
    var split = time.split(':');
    if (time.endsWith('AM')) {
        if (parseFloat(split[0]) !== 12) {
            result.hour = parseFloat(split[0]);
        }
    }
    else if (time.endsWith('PM')) {
        result.hour =
            parseFloat(split[0]) + (parseFloat(split[0]) === 12 ? 0 : 12);
    }
    else {
        result.hour = parseFloat(split[0]);
    }
    result.minute = parseFloat(split[1]);
    return result;
}
function timeToString(timeValue, formatting) {
    if (!formatting.includes('A')) {
        return twoDigits(timeValue.hour) + ":" + twoDigits(timeValue.minute);
    }
    return (timeValue.hour === 12 || timeValue.hour === 0
        ? 12
        : twoDigits(timeValue.hour % 12)) + ":" + twoDigits(timeValue.minute) + " " + (timeValue.hour >= 12 ? 'PM' : 'AM');
}
function twoDigits(value) {
    return (value < 10 ? '0' : '') + value;
}
function getTimeZoneOffsetMilliseconds(timeZoneOffsetSeconds) {
    return ((lodash_1.isNil(timeZoneOffsetSeconds)
        ? getCurrentTimeZoneOffsetInSeconds()
        : timeZoneOffsetSeconds) * 1000);
}
function getCurrentTimeZoneOffsetInSeconds() {
    return -new Date().getTimezoneOffset() * 60;
}
// Wait adventurer, there is Zone Magic, be vigilant
function reinterpretDateInGivenZoneAndReturnAsUTCDateAndTime(datetime, offsetInMilliSeconds) {
    // equivalent to getting from datetime by given time zone
    // equivalent to (datetime - currentZoneOffset + givenOffset) and get by current zone or
    var shiftedDate = new Date(datetime.getTime() + offsetInMilliSeconds);
    return [
        new Date(Date.UTC(shiftedDate.getUTCFullYear(), shiftedDate.getUTCMonth(), shiftedDate.getUTCDate())),
        {
            hour: shiftedDate.getUTCHours(),
            minute: shiftedDate.getUTCMinutes(),
            seconds: shiftedDate.getUTCSeconds(),
        },
    ];
}
//# sourceMappingURL=sis-date-time-picker.component.js.map